module.exports = __webpack_public_path__ + "img/r9.dfb888d1.jpg";